
export default {
  name: "HowWorkCard",

  props: {
    item: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    number: function () {
      return String(this.item?.number).padStart(2, '0')
    }
  }
}
